import { Component, OnInit } from '@angular/core';
import { CommentService } from '../services/comment.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { formatDate } from '@angular/common';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-comment',
  templateUrl: './comment.component.html',
  styleUrls: ['./comment.component.scss']
})
export class CommentComponent implements OnInit {
  public tccno : string;
  public comments : Array<Icomment>;
  public usersComment$: Observable<boolean>;
  commentForm : FormGroup;
  public user : any;
  public msg : string;
  
  constructor(private commentservice : CommentService,
              private fb: FormBuilder, private authservice: AuthService) {
    this.tccno =localStorage.getItem("tccno");
    this.user = this.authservice.getCurrentUser();
   }

   private createAddCommentForm(){
     this.commentForm = this.fb.group({
      tccNo: [this.tccno, Validators.compose([Validators.required, Validators.maxLength(13)])],
      usergroup: [this.user.sub+"-"+this.user.usergroup, Validators.compose([Validators.required])],
      commentDate: [],
      comments: ['', Validators.compose([Validators.required, Validators.maxLength(150)])]
     })
   }

  ngOnInit() {
    this.usersComment$ = this.commentservice.getComment(this.tccno).pipe(tap(r => {
      this.comments = this.commentservice.comment;
      //console.log(this.comments);
    }))
    this.createAddCommentForm();
  }

  public addComment(){
    this.commentservice.addComment(this.commentForm.value).subscribe(data => {
     console.log(data);
    }, error => {
      console.log(this.comments);
    });
  }

}
